import { render, staticRenderFns } from "./LabelsAndCertifications.vue?vue&type=template&id=038bd081&"
import script from "./LabelsAndCertifications.vue?vue&type=script&lang=ts&"
export * from "./LabelsAndCertifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports